import { token } from '@cp/shared/di';
import { ClientRegistrationState } from '@common/model/client/registration/registrationState';

export const GET_CLIENT_SELECTIONS = token<() => Promise<Partial<ClientRegistrationState>>>('registration/GET_CLIENT_SELECTIONS');
